"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderWidget = void 0;
const edit_1 = require("client/components/icons/edit");
const icon_button_1 = require("client/components/material/icon-button");
const router_1 = require("client/components/router");
const store_1 = require("client/modules/dashboard/store");
const store_2 = require("client/modules/sites/modules/sites-detail/store");
const store_3 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const upload_1 = require("shared/upload");
const capitalize_string_1 = require("shared/util/capitalize-string");
const uppercase_string_1 = require("shared/util/uppercase-string");
const icons_1 = require("../../../../../../components/icons");
require("./provider-widget.less");
const moment = require("moment");
let ProviderWidget = class ProviderWidget extends React.Component {
    constructor() {
        super(...arguments);
        this.provider = {};
        this.user = {};
        this.providerLoaded = false;
        this.modalActive = false;
        this.staff = [];
        this.handleError = (event) => {
            alert(`error ${event.target.src}`);
            event.target.src = "/assets/users.png";
        };
        this.handleDeleteUpdate = () => {
            this.provider = this.props.provider;
        };
        this.handleUpdateStaff = async (providerId) => {
            await store_1.dashboardStore.getProviderWidget(providerId);
            this.provider = store_1.dashboardStore.provider;
            this.getProviderImage();
        };
        this.getProviderImage = () => {
            try {
                this.providerImage = store_1.dashboardStore.provider.uploads.reduce((accu, upload) => {
                    let newAccu = accu;
                    if (upload.informationType === upload_1.InformationType.ProviderImage) {
                        newAccu = upload.filePath;
                    }
                    return newAccu;
                }, "");
            }
            catch (error) {
                this.providerImage = "assets/users.png";
            }
        };
    }
    /**
     * Load provider associated with user logged in from store before rendering
     * the the widget.
     */
    async componentWillMount() {
        this.providerLoaded = false;
        this.user = await store_3.usersStore.user.value;
        if (this.props.user) {
            const site = this.user.site;
            const siteId = site.id;
            this.picId = site.picProviderId;
            await store_1.dashboardStore.getProviderWidget(this.picId);
            await store_2.sitesDetailStore.loadProviders({
                id: siteId,
                order: "ASC"
            });
            /** Includes full list of site staff, where Pic is Provider In Charge */
            const staffWithPic = mobx_1.toJS(store_2.sitesDetailStore.providers.value);
            const staffWithoutPic = staffWithPic.filter((provider) => provider.id !== this.picId);
            this.staff = staffWithPic;
            this.provider = store_1.dashboardStore.provider;
            this.providerLoaded = true;
            this.getProviderImage();
        }
        if (this.props.provider) {
            this.handleDeleteUpdate();
        }
    }
    render() {
        if (!this.providerLoaded)
            return React.createElement("div", null);
        if (this.provider) {
            const { id, dea, deaExp, email, firstName, lastName, notes, npiNumber, phone, state, stateLicense, stateLicenseExp, title } = store_1.dashboardStore.provider;
            let providerAssigned;
            let fullName;
            let assets;
            if (firstName) {
                providerAssigned = "";
                fullName = `${capitalize_string_1.capitalizeString(firstName)} ${capitalize_string_1.capitalizeString(lastName)}, ${title}`;
                assets = true;
            }
            else {
                providerAssigned = "No Providers Assigned";
                fullName = "None Assigned";
                assets = false;
            }
            return (React.createElement("div", { className: "provider-widget widget" }, store_3.usersStore.permissions.ReadProvider ? (React.createElement("div", { className: "provider-widget__provider" },
                React.createElement("div", { className: "provider-widget__provider-list" },
                    React.createElement("h3", null, "Assigned Staff"),
                    this.staff.length > 0 ? (React.createElement("ul", null, this.staff.map((prsn, index) => {
                        const providerName = `${capitalize_string_1.capitalizeString(prsn.firstName)} ${capitalize_string_1.capitalizeString(prsn.lastName)} ${prsn.title ? `, ${uppercase_string_1.uppercaseString(prsn.title)}` : ""}`;
                        return (React.createElement("li", { key: index, onClick: () => this.handleUpdateStaff(prsn.id) },
                            React.createElement(icons_1.UsersIcon, null),
                            providerName));
                    }))) : (React.createElement("p", null, "No staff available."))),
                React.createElement("div", { className: "provider-widget__provider--profile" },
                    React.createElement("div", { className: "provider-widget__provider--physician" },
                        React.createElement("h3", null, fullName),
                        id === this.picId && React.createElement("p", null, "Physician in Charge"),
                        React.createElement("div", { className: "provider-widget__avatar" },
                            React.createElement("img", { src: this.props.image || "/assets/users.png", width: "50%", height: "50%" }),
                            assets ? (React.createElement("div", { className: "provider-widget__provider-menu" },
                                React.createElement("div", { style: { textAlign: "left" } },
                                    React.createElement(icon_button_1.MaterialIconButton, { onClick: () => router_1.RouteManager.transitionTo(`/pharmacies/${this.props.site.id}/providers/${this.provider.id}`) },
                                        React.createElement(edit_1.EditIcon, null)),
                                    React.createElement("span", null, "Edit Provider Information")))) : null)),
                    React.createElement("div", { className: "provider-widget__provider--details" },
                        React.createElement("div", { className: "provider-widget__provider--dea" },
                            React.createElement("h4", null, "DEA: "),
                            " ",
                            React.createElement("span", null, dea)),
                        React.createElement("div", { className: "provider-widget__provider--npi" },
                            React.createElement("h4", null, "NPI: "),
                            " ",
                            React.createElement("span", null, npiNumber)),
                        React.createElement("div", { className: "provider-widget__provider--email" },
                            React.createElement("h4", null, "Email: "),
                            React.createElement("span", null,
                                React.createElement("a", { href: `mailto:${email}` }, email))),
                        React.createElement("div", { className: "provider-widget__provider--phone" },
                            React.createElement("h4", null, "Phone: "),
                            " ",
                            React.createElement("span", null, phone)),
                        React.createElement("div", { className: "provider-widget__provider--state" },
                            React.createElement("h4", null, "State: "),
                            " ",
                            React.createElement("span", null, state)),
                        React.createElement("div", { className: "provider-widget__provider--statelicense" },
                            React.createElement("h4", null, "State License: "),
                            " ",
                            React.createElement("span", null, stateLicense)),
                        React.createElement("div", { className: "provider-widget__provider--statelicenseexp" },
                            React.createElement("h4", null, "State License Exp.: "),
                            " ",
                            React.createElement("span", null, stateLicenseExp &&
                                moment(stateLicenseExp)
                                    .format("ll")
                                    .toString())),
                        React.createElement("div", { className: "provider-widget__provider--notes" },
                            React.createElement("h4", null, "Notes: "),
                            " ",
                            React.createElement("span", null, notes)))))) : (store_3.usersStore.showLock())));
        }
        else {
            return (React.createElement("div", { className: "provider-widget widget" },
                React.createElement("h4", { className: "widget__header" }, "Clinic Providers"),
                "No provider has been assigned to this pharmacy."));
        }
    }
};
__decorate([
    mobx_1.observable
], ProviderWidget.prototype, "provider", void 0);
__decorate([
    mobx_1.observable
], ProviderWidget.prototype, "picId", void 0);
__decorate([
    mobx_1.observable
], ProviderWidget.prototype, "user", void 0);
__decorate([
    mobx_1.observable
], ProviderWidget.prototype, "providerLoaded", void 0);
__decorate([
    mobx_1.observable
], ProviderWidget.prototype, "providerImage", void 0);
__decorate([
    mobx_1.observable
], ProviderWidget.prototype, "modalActive", void 0);
__decorate([
    mobx_1.observable
], ProviderWidget.prototype, "staff", void 0);
ProviderWidget = __decorate([
    mobx_react_1.observer
], ProviderWidget);
exports.ProviderWidget = ProviderWidget;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/provider-widget/provider-widget.tsx
// module id = 3371
// module chunks = 0